import React from 'react';
import classNames from 'classnames';
import { Heading, PropertyGroup } from '../../components';
import { useIntl } from '../../util/reactIntl';

import css from './CustomExtendedDataSection.module.css';

const SectionMultiEnum = props => {
  const {
    heading,
    fieldKey,
    options,
    selectedOptions,
    idPrefix,
    className,
    rootClassName,
    showUnselectedOptions = true,
  } = props;

  const intl = useIntl();
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }

  // Try a translation key derived from the field key (e.g. listingField.serviceType.label).
  // Fall back to the raw label coming from the Sharetribe Console API.
  if (process.env.NODE_ENV === 'development' && fieldKey) {
    console.log(`[i18n] Add translation key: "listingField.${fieldKey}.label": "${heading}"`);
  }
  const translationKey = fieldKey ? `listingField.${fieldKey}.label` : null;
  const translatedHeading = translationKey
    ? intl.formatMessage({ id: translationKey, defaultMessage: heading })
    : heading;

  const idSlug = heading.toLowerCase().replace(/ /g, '_');
  const classes = classNames(rootClassName || css.sectionMultiEnum, className);

  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {translatedHeading}
      </Heading>
      <PropertyGroup
        id={`${idPrefix}.${idSlug}`}
        ariaLabel={translatedHeading}
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnum;
